// Song & dance

//
import mprMetaDataProvider from './lib/mprMetadata/mprMetaDataProvider.js';
import mprImageLoader from './mprImageLoader.js'
import MprTool from './MprTool.js';
import MprMouseWheelTool from './MprMouseWheelTool.js';
import MPR from "@/utils/MPR/MPR.class";

export default function(seriesNumber) {

  _initCornerstoneTools();
  cornerstone.registerImageLoader('mpr', mprImageLoader);
  cornerstone.metaData.addProvider(mprMetaDataProvider);

  // Enable Elements

  const mprAxialSeriesElement = MPR.axialSeriesDom;
  const mprCoronalSeriesElement = MPR.coronalSeriesDom
  const mprSagittalSeriesElement = MPR.sagittalSeriesDom
//   const mprAxialSeriesElement = document.getElementById("axial-target");
//   const mprCoronalSeriesElement = document.getElementById("coronal-target");
//   cornerstone.enable(mprAxialSeriesElement, {
//       renderer: "webgl"
//   });

//   cornerstone.enable(mprCoronalSeriesElement, {
//       renderer: "webgl"
//   });

//   cornerstone.enable(mprSagittalSeriesElement, {
//     renderer: "webgl"
// });


  cornerstoneTools.addToolForElement(mprAxialSeriesElement, MprTool, {
      configuration: { rotationAxis: 'Y' }
  });
  cornerstoneTools.addToolForElement(mprCoronalSeriesElement, MprTool, {
      configuration: { rotationAxis: 'X' }
  });
  cornerstoneTools.addToolForElement(mprSagittalSeriesElement, MprTool, {
    configuration: { rotationAxis: 'X' }
});

  // Track data for this tool using STACK state
  cornerstoneTools.addStackStateManager(mprAxialSeriesElement, ["Mpr"])
  const mprAxialSeriesStack = {
      currentImageIdIndex: 0,
      imageIds: [`mpr:${seriesNumber}:1,0,0,0,1,0:center`],
  }

  cornerstoneTools.clearToolState(mprAxialSeriesElement, 'stack')
  cornerstoneTools.addToolState(mprAxialSeriesElement, 'stack', mprAxialSeriesStack)

  cornerstoneTools.addStackStateManager(mprCoronalSeriesElement, ["Mpr"])
  const mprCoronalSeriesStack = {
      currentImageIdIndex: 0,
      imageIds: [`mpr:${seriesNumber}:1,0,0,0,0,-1:center`],
  }

  cornerstoneTools.clearToolState(mprCoronalSeriesElement, 'stack')
  cornerstoneTools.addToolState(mprCoronalSeriesElement, 'stack', mprCoronalSeriesStack)
  cornerstoneTools.addStackStateManager(mprSagittalSeriesElement, ["Mpr"])
  const mprSagittalSeriesStack = {
      currentImageIdIndex: 0,
      imageIds: [`mpr:${seriesNumber}:0,1,0,0,0,-1:center`],
  }

  cornerstoneTools.clearToolState(mprSagittalSeriesElement, 'stack')
  cornerstoneTools.addToolState(mprSagittalSeriesElement, 'stack', mprSagittalSeriesStack)
  

  // Element Specific Tools
  //
  cornerstoneTools.setToolActiveForElement(mprAxialSeriesElement, "MprMouseWheel", {});
  cornerstoneTools.setToolActiveForElement(mprCoronalSeriesElement, "MprMouseWheel", {}); 
  cornerstoneTools.setToolActiveForElement(mprSagittalSeriesElement, "MprMouseWheel", {});
  //
  cornerstoneTools.setToolActiveForElement(mprAxialSeriesElement, "Mpr", { mouseButtonMask: 1, color: '#ff7e00', cosines: "1,0,0,0,1,0" });
  cornerstoneTools.setToolActiveForElement(mprCoronalSeriesElement, "Mpr", { mouseButtonMask: 1, color: '#ff7e00', cosines: "1,0,0,0,0,-1" });
  cornerstoneTools.setToolActiveForElement(mprSagittalSeriesElement, "Mpr", { mouseButtonMask: 1, color: '#ff7e00', cosines: "0,1,0,0,0,-1" });

}

function _initCornerstoneTools(){
  // cornerstoneTools.init({
  //     globalToolSyncEnabled: true
  // });

  // Grab Tool Classes
  const WwwcTool = cornerstoneTools.WwwcTool;
  const PanTool = cornerstoneTools.PanTool;
  const PanMultiTouchTool = cornerstoneTools.PanMultiTouchTool;
  const StackScrollMouseWheelTool = cornerstoneTools.StackScrollMouseWheelTool;
  const ZoomTool = cornerstoneTools.ZoomTool;
  const ZoomTouchPinchTool = cornerstoneTools.ZoomTouchPinchTool;
  const ZoomMouseWheelTool = cornerstoneTools.ZoomMouseWheelTool;

  // Add them
  // cornerstoneTools.addTool(PanTool);
  // cornerstoneTools.addTool(ZoomTool);
  // cornerstoneTools.addTool(WwwcTool);
  // cornerstoneTools.addTool(MprTool);
  // cornerstoneTools.addTool(PanMultiTouchTool);
  // cornerstoneTools.addTool(StackScrollMouseWheelTool);
  // cornerstoneTools.addTool(ZoomTouchPinchTool);
  // cornerstoneTools.addTool(ZoomMouseWheelTool);
  cornerstoneTools.addTool(MprMouseWheelTool);

  // // Set tool modes
  // cornerstoneTools.setToolActive("Pan", { mouseButtonMask: 4 }); // Middle
  // cornerstoneTools.setToolActive("Zoom", { mouseButtonMask: 2 }); // Right
  // // cornerstoneTools.setToolActive("Wwwc", { mouseButtonMask: 1 }); // Left & Touch
  // cornerstoneTools.setToolActive("PanMultiTouch", {});
  // cornerstoneTools.setToolActive("ZoomTouchPinch", {});
}